import './ACED.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class ACED extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initAddressValidation();
	}

	async initAddressValidation () {
		const addressValidationElement = document.getElementById('address-validation');

		if (!addressValidationElement) {
			return;
		}

		const {AddressValidation} = await import('extensions/address-validation');

		new AddressValidation(addressValidationElement);
	}

}
